<script setup>
import { onMounted, ref } from "vue";
import Dropdown from "primevue/dropdown";
import { carregarDisciplinas } from '@/api/fetchDisciplinas';

const model = defineModel();
const disciplinas = ref([]);
const loading = ref(false);

onMounted(async () => { 
    loading.value = true;
    disciplinas.value = await carregarDisciplinas();
    loading.value = false;
});


</script>
<template>
    <div class="flex flex-column gap-2">
        <label for="topico">Disciplina</label>
        <Dropdown v-model="model" :options="disciplinas" optionLabel="nome" :loading="loading" optionValue="id"
            placeholder="Selecione um tipo de pergunta" class="w-full" />
    </div>
</template>